import classNames from 'classnames';
import React from 'react';
import { ContentArea } from '../content-area/content-area.react-component';
import styles from "./one-pane-layout.module.css";
/** Props for OnePaneLayoutContainer component */

/**
 * ### OnePaneLayoutContainer Component
 *
 * @remarks
 *
 * Implements centered pane page layout. Includes the
 * {@link ContentArea} container.
 */
export const OnePaneLayoutContainer = _ref => {
  let {
    className,
    children,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames('ud-container', className)
  }, props), /*#__PURE__*/React.createElement(ContentArea, null, children));
};
/**
 * ### OnePaneLayoutFullWidthSection Component
 *
 * @remarks
 *
 * Within a {@link OnePaneLayoutContainer}, this component renders a full-width section.
 * Use `className` to apply a background color, for example.
 *
 * To reestablish the centered margin content area within this full-width section,
 * use the {@link OnePaneLayoutFullWidthSectionContent} component.
 */

export const OnePaneLayoutFullWidthSection = _ref2 => {
  let {
    backgroundColor,
    className,
    children,
    ...props
  } = _ref2;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames('ud-full-viewport-container', backgroundColor ? styles[backgroundColor] : undefined, className)
  }, props), children);
};
/**
 * ### OnePaneLayoutFullWidthSectionContent Component
 *
 * @remarks
 *
 * Within a {@link OnePaneLayoutFullWidthSection}, this component reestablishes a centered
 * content area with margins, matching the layout of the {@link OnePaneLayoutContainer}.
 */

export const OnePaneLayoutFullWidthSectionContent = _ref3 => {
  let {
    className,
    children,
    ...props
  } = _ref3;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: classNames('ud-container', className)
  }, props), children);
};
OnePaneLayoutFullWidthSection.Content = OnePaneLayoutFullWidthSectionContent;
//# sourceMappingURL=one-pane-layout.react-component.js.map